import { useState } from 'react';
import { useAuthenticatedFetchWithWorkspace } from '../Keycloak/useAuthenticatedFetchWithWorkspace';

const useDeleteUrl = () => {
    const { authFetch, isReady, workspaceId } = useAuthenticatedFetchWithWorkspace();
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string>('');

    const deleteUrl = async (entEntityUrlId: string | number): Promise<boolean> => {
        if (!isReady || !workspaceId) {
            setError('Workspace not ready');
            return false;
        }

        setIsLoading(true);
        setError('');
        try {
            await authFetch('/deleteEntEntityUrl', {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ ent_entity_url_id: entEntityUrlId }),
            });
            return true;
        } catch (err: unknown) {
            const message = err instanceof Error ? err.message : 'Unknown error while deleting the URL.';
            console.error('[useDeleteUrl] failed:', { workspaceId, entEntityUrlId, message });
            setError(message);
            return false;
        } finally {
            setIsLoading(false);
        }
    };

    return { deleteUrl, isLoading, error };
};

export default useDeleteUrl;
